import React from "react";
import ComplianceIframe from "../../iframe-component/compliance/ComplianceIframe";

/**
 * Transaction monitoring — the compliance platform's own dashboard, alert
 * queue, case follow-through, baselines and tuning, all reached from the nav
 * inside the frame. One tab rather than six, because the portal keeps every
 * open tab mounted and each extra tab is another full app load.
 */
const TransactionMonitoring = () => {
  return <ComplianceIframe path="/" />;
};

export default React.memo(TransactionMonitoring);
